import React, { useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { hideCookieBanner } from '../../actions';
import { cookieDomain } from '../../config';
import { cookieLink } from '../../constants';
import { Store } from '../../reducers';
import styles from './CookieBanner.module.scss';

const TopCookieBanner = (): React.ReactElement => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const { displayCookieBanner } = useSelector((state: Store) => state.app);
    const setCookie = (): void => {
        const aYearFromNow = moment().add(1, 'years').utc().format('ddd, DD MMM YYYY, HH:mm:ss');
        document.cookie = `accepts-cookies=true; expires=${aYearFromNow} UTC; path=/; domain=${cookieDomain}`;
        dispatch(hideCookieBanner());
        window.removeEventListener('scroll', setCookie);
    };

    useEffect(() => {
        if (displayCookieBanner) {
            window.addEventListener('scroll', setCookie);
        }
    }, []);

    if (!displayCookieBanner) {
        return <div />;
    }

    return (
        <div className={styles.banner}>
            <span className={styles.message}>
                {txt('CookiePolicy')}
                <a className={styles.link} href={cookieLink} rel="noopener noreferrer" target="_blank">
                    {txt('CookiePolicyLinkText')}
                </a>
            </span>
            <button type="button" onClick={setCookie} className={styles.button}>
                {txt('Close')}
            </button>
        </div>
    );
};

export default TopCookieBanner;
